import $ from 'jquery';
/**
 * Enables the "network" page functionality.
 */
const enableNetworkFunctionality = () => {
    if ($('#network').length === 0) {
        return;
    }
    _setBvlosBackgroundHeight();
    $(window).on('resize', _setBvlosBackgroundHeight);
    /**
     * Sets the height of the "BVLOS" background image.
     */
    function _setBvlosBackgroundHeight() {
        const innerWidth = ($(window).innerWidth() || 1);
        const background = $('.background-bvlos');
        if (window.matchMedia('(min-width: 576px)').matches) {
            background.css('height', (870 / (1800 / innerWidth)));
        }
        else {
            background.css('height', (1139 / (639 / innerWidth)));
        }
    }
};
export default enableNetworkFunctionality;
